import { createFileRoute } from '@tanstack/react-router'
import { XpLabFeedbackPage } from '@/components/infoPages/XpLabFeedbackPage'
import { withPublicPageSeo } from '@/modules/seo'

const XpLabFeedbackPageWithSeo = withPublicPageSeo(
  'feedbackWorks',
  XpLabFeedbackPage
)

export const Route = createFileRoute('/xp-lab-feedback')({
  component: XpLabFeedbackPageWithSeo,
})
